import { useEffect } from 'react';
import { adSenseConfig } from '../../config/adsense';

export function AdSenseScript(): null {
  useEffect(() => {
    if (!adSenseConfig.enabled) return;

    const selector = `script[data-skullking-adsense-client="${adSenseConfig.client}"]`;
    if (document.head.querySelector(selector)) return;

    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adSenseConfig.client}`;
    script.dataset.skullkingAdsenseClient = adSenseConfig.client;
    document.head.appendChild(script);

    return () => script.remove();
  }, []);

  return null;
}
